// Het overzicht van een wervingsactie als CSV-rijen, uit dezelfde kolommen als
// het scherm (rollupColumns), zodat scherm en bestand dezelfde getallen geven.
// Eén waarde per cel: een telling met percentage wordt twee kolommen, en
// 'onbekend' wordt een lege cel — geen nul, en geen streepje om op te filteren.
//
// AI-CONTEXT: See docs/patterns.md#ui-csv-export
// AI-CONTEXT: See docs/features/wervingsacties-registratie.md (Uitbreiding 2026-10 (2))

/**
 * @param {object} args
 * @param {Array<import('../wervingsacties/rollupColumns').RollupKolom>} args.kolommen - Uit rollupColumns
 * @param {object} args.totals - De totaalregel uit buildRollup, met `label`
 * @param {Array<object>} args.rows - De regels uit buildRollup
 * @returns {{ rows: Array<Record<string, string | number>>, header: Array<string> }}
 */
const buildWervingsRollupExportRows = ({ kolommen, totals, rows }) => {
    // Een CSV-rij is een object per kolomkop, dus twee kolommen met dezelfde
    // naam (een verborgen 'Fixer' naast een nieuwe) zouden er één worden en
    // het getal van de eerste kwijtraken. Daarom een unieke kop per kolom.
    const gezien = new Map()
    /** @param {string} label @returns {string} */
    const uniek = (label) => {
        const n = (gezien.get(label) || 0) + 1
        gezien.set(label, n)
        return n === 1 ? label : `${label} (${n})`
    }
    const koppen = kolommen.map((k) => ({ kolom: k, kop: uniek(k.label) }))
    const header = koppen.flatMap(({ kolom, kop }) => (kolom.pct ? [kop, `${kop} %`] : [kop]))

    /**
     * @param {object} row
     * @param {boolean} isTotaal
     * @returns {Record<string, string | number>}
     */
    const naarRij = (row, isTotaal) => Object.fromEntries(koppen.flatMap(({ kolom: k, kop }) => {
        if (isTotaal && k.alleenPerRegel) return [[kop, '']]
        const waarde = k.value(row)
        const cel = waarde === null || waarde === undefined ? '' : waarde
        if (!k.pct) return [[kop, cel]]
        const procent = k.pct(row)
        return [[kop, cel], [`${kop} %`, procent === null || procent === undefined ? '' : procent]]
    }))

    return { header, rows: [naarRij(totals, true), ...rows.map((row) => naarRij(row, false))] }
}

export default buildWervingsRollupExportRows
